import React from 'react';
import { Toaster } from 'react-hot-toast';
import ChargingStationSimulator from './components/ChargingStationSimulator';
import Dashboard from './components/Dashboard';
import SessionsView from './components/SessionsView';
import { WebSocketProvider } from './contexts/WebSocketContext';

function App() {
  return (
    <WebSocketProvider>
      <div className="min-h-screen bg-gray-50">
        <Toaster position="top-right" />
      
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <h1 className="text-xl font-bold text-gray-900">
                  EV Charging Station Simulator & CCMS
                </h1>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8 space-y-8">
        {/* Charging Station Simulator */}
        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Charging Station Simulator</h2>
          <ChargingStationSimulator />
        </section>

        {/* Divider */}
        <div className="border-t border-gray-200"></div>

        {/* CCMS Dashboard */}
        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-6">CCMS Dashboard</h2>
          <Dashboard />
        </section>

        {/* Divider */}
        <div className="border-t border-gray-200"></div>

        {/* Charging Sessions */}
        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Charging Sessions</h2>
          <SessionsView />
        </section>
      </main>
      </div>
    </WebSocketProvider>
  );
}

export default App;